module.exports = __webpack_public_path__ + "img/34418882bbde26552a6cab3be43fbfe0.34418882.png";